import { Box, Button, Grid, InputAdornment, TextField, Typography } from '@mui/material'
import React, { } from 'react'
import RadioBoxGroup from '../../components/RadioButtons/RadioBoxGroup'
import WeekdayToggleButtons from './WorkTimeLimits/WeekdayToggleButtons';
import ToggleSwitch from '../../components/ToggleSwitch/ToggleSwitch';
const labelStyle = {
  marginBottom: '4px',
  fontWeight: 600,
  color: '#1A1A1A',
  fontSize: { xl: '14px', lg: '14px', md: '13px', sm: '14px', xs: '14px' },
};

const inputStyle = {
  height: '46px',
  backgroundColor: '#fff',
  fontSize: '13px',
};

const WorkTimeLimits = () => {
  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
        <Typography sx={{ fontSize: '16px', fontWeight: '600', color: '#1A1F36', }}>Use shifts to set work allowance limits</Typography>
        <RadioBoxGroup
          options={['Yes', 'No']}
          defaultValue="Yes"
          row={true}
        /></Box>

      <Box mt={2} mb={2}>
        <Typography variant="body2" sx={{ fontSize: { xl: '18px', lg: '16px', md: '16px', sm: '16px', xs: '14px' }, fontWeight: '600', color: '#1A1F36', }}>
          Weekly work days
        </Typography>
        <Typography variant="body2" sx={{ fontSize: { xl: '14px', lg: '12px', md: '12px', sm: '12px', xs: '12px' }, fontWeight: '400', color: '#9095A1', mb: 2 }}>
          Specify weekdays for team presence and any days when time tracking is not allowed.
        </Typography>
        <Typography variant="body2" sx={{ fontSize: { xl: '18px', lg: '16px', md: '16px', sm: '16px', xs: '14px' }, fontWeight: '600', color: '#1A1F36', mb: 1 }}>
          Expected work days: Mon - Fri
        </Typography>
        <WeekdayToggleButtons />
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, }}>
        <Typography sx={{ fontSize: { xl: '18px', lg: '16px', md: '16px', sm: '16px', xs: '14px' }, fontWeight: '600', color: '#1A1F36', }}>  Disable time tracking on specific days</Typography> <ToggleSwitch />
      </Box>

      <Grid container spacing={2}>
        {/* Expected Weekly Work Hours */}
        <Grid item size={{ xs: 12, md: 4 ,  sm: 6 }}>
          <Typography variant="body2" sx={labelStyle}>
            Expected weekly work hours
          </Typography>
          <Typography variant="caption" color="text.secondary" mb={1} display="block">
            Set expected weekly hours.
          </Typography>
          <TextField
            fullWidth
            placeholder="No expected hours"
            variant="outlined"
            InputProps={{
              sx: inputStyle,
              endAdornment: <InputAdornment position="end">hrs/wk</InputAdornment>
            }}
          />
        </Grid>
        <Grid item size={{ xs: 12, md: 4 ,  sm: 6 }}>
          <Typography variant="body2" sx={labelStyle}>
            Weekly limit
          </Typography>
          <Typography variant="caption" color="text.secondary" mb={1} display="block">
            Set max weekly hours.
          </Typography>
          <TextField
            fullWidth
            placeholder="No weekly limit"
            variant="outlined"
            InputProps={{
              sx: inputStyle,
              endAdornment: <InputAdornment position="end">hrs/wk</InputAdornment>
            }}
          />
        </Grid>
        <Grid item size={{ xs: 12, md: 4 , sm: 12 }}>
          <Typography variant="body2" sx={labelStyle}>
            Daily limit
          </Typography>
          <Typography variant="caption" color="text.secondary" mb={1} display="block">
            Set daily hours for members.
          </Typography>
          <TextField
            fullWidth
            placeholder="No daily limit"
            variant="outlined"
            InputProps={{
              sx: inputStyle,
              endAdornment: <InputAdornment position="end">hrs/day</InputAdornment>
            }}
          />
        </Grid>
        <Grid item size={{ xs: 12, md: 12 }} sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 2 }}>
          <Button
            variant="outlined"
            color="inherit"
            sx={{
              fontSize: '14px',
              borderRadius: '50px',
              background: '#fff',
              border: '1px solid #9095A1',
              color: '#9095A1',
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            sx={{
              fontSize: '14px',
              borderRadius: '50px',
              background: '#0076FE',
              border: '1px solid #0076FE',
              color: '#fff',
            }}
          >
            Save & Update
          </Button>
        </Grid>
      </Grid>




    </>
  )
}

export default WorkTimeLimits
